import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const token = localStorage.getItem("bearerToken");

  console.log("ProtectedRoute token:", token); // debug

    // if (!token) {
    //   return <Navigate to="/login" replace />;
    // }

  return <Outlet />;
};

export default ProtectedRoute;    
